import { render } from "./UiButton.vue?vue&type=template&id=79ec39e8&scoped=true"
import script from "./UiButton.vue?vue&type=script&lang=js"
export * from "./UiButton.vue?vue&type=script&lang=js"

import "./UiButton.vue?vue&type=style&index=0&id=79ec39e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ec39e8"]])

export default __exports__